import Button from 'shared/components/Button'

import styles from '../styles.module.scss'

const SubscriptionLiteForm = ({ language }) => (
    <>
        <T>subscription.lite.confirmation</T>
        <Button
            className={`mt-3 ${styles.proceedButton}`}
            size="large"
            internal
            href={`https://indigoneo.ca/${language}/monthly-parking/`}>
            <T>subscription.lite.proceed</T>
        </Button>
    </>
)

export default SubscriptionLiteForm
